import React from "react";
import styles from "./style.module.css";

// --- Reusable TextInput Component ---
interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  id: string;
}

const TextInput: React.FC<TextInputProps> = ({ label, id, ...props }) => {
  return (
    <div className={styles.formGroup}>
      <label htmlFor={id}>{label}</label>
      <input id={id} {...props} />
    </div>
  );
};

// --- Helper Icon Component ---
const EditIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

// --- Main BuyerProfilePage Component ---
export const BuyerProfilePage: React.FC = () => {
  return (
    <div className={styles.buyerProfile}>
      <header className={styles.profileHeader}>
        <img
          src="https://placehold.co/600x400/"
          alt="John Thomas"
          className={styles.profileImage}
        />
        <h1 className={styles.profileName}>John Thomas</h1>
        <p className={styles.profileEmail}>johnthomas@gmail.com</p>
      </header>

      <main className={styles.infoContainer}>
        <div className={styles.leftColumn}>
          {/* Card for Personal Information */}
          <section className={styles.infoCard}>
            <div className={styles.cardHeader}>
              <h2 className={styles.cardTitle}>Personal Information</h2>
              <a href="#edit-personal" className={styles.editLink}>
                Edit <EditIcon />
              </a>
            </div>
            <form>
              <TextInput
                label="Display Name"
                id="displayName"
                type="text"
                defaultValue="John Thomas"
                disabled={false}
              />
              <TextInput
                label="Email Address"
                id="email"
                type="email"
                defaultValue="Johnthomas@gmail.com"
                disabled={false}
              />
              <TextInput
                label="Phone Number"
                id="phone"
                type="tel"
                defaultValue="07032459226"
                disabled={false}
              />
            </form>
          </section>

          {/* Card for Changing Password */}
          <section className={styles.infoCard}>
            <div className={styles.cardHeader}>
              <h2 className={styles.cardTitle}>Change Password</h2>
            </div>
            <form>
              <TextInput
                label="Password"
                id="password"
                type="password"
                placeholder="**********"
                disabled={false}
              />
              <TextInput
                label="New Password"
                id="newPassword"
                type="password"
                placeholder="**********"
                disabled={false}
              />
            </form>
          </section>
        </div>

        {/* Card for Primary Address */}
        <section className={styles.infoCard}>
          <div className={styles.cardHeader}>
            <h2 className={styles.cardTitle}>Primary Address</h2>
            <a href="#edit-address" className={styles.editLink}>
              Edit <EditIcon />
            </a>
          </div>
          <form>
            <TextInput
              label="Street Name"
              id="streetName"
              type="text"
              defaultValue="Thomsone Akpabio"
              disabled={false}
            />
            <TextInput
              label="State/City"
              id="stateCity"
              type="text"
              defaultValue="Uyo"
              disabled={false}
            />
            <TextInput
              label="Postal Code"
              id="postalCode"
              type="text"
              defaultValue="1234567"
              disabled={false}
            />
            <TextInput
              label="Full Address"
              id="fullAddress"
              type="text"
              defaultValue="Shelter Afrique, Thomson streetUyo, Akwa Ibom"
              disabled={false}
            />
            <TextInput
              label="Additional Information"
              id="additionalInfo"
              type="text"
              placeholder=""
              disabled={false}
            />
          </form>
        </section>
      </main>

      <button className={styles.saveButton}>Save</button>
    </div>
  );
};
